import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#183555",
            contrastText: "#ffffff",
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                color: "primary",
            },
            styleOverrides: {
                contained: {
                    backgroundColor: "#183555",
                    color: "#fff",
                    "&:hover": {
                        backgroundColor: "#122f47",
                    },
                },
                outlined: {
                    borderColor: "#183555",
                    color: "#183555",
                    "&:hover": {
                        backgroundColor: "rgba(24,53,85,0.04)",
                    },
                },
                text: {
                    color: "#183555",
                    "&:hover": {
                        backgroundColor: "rgba(24,53,85,0.04)",
                    },
                },
            },
        },
        MuiIconButton: {
            defaultProps: {
                color: "primary",
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    "&.MuiChip-colorInfo": {
                        backgroundColor: "#183555",
                        color: "#fff",
                    },
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#183555",
                    color: "#fff",
                },
            },
        },
        MuiCircularProgress: {
            defaultProps: {
                color: "primary",
            },
        },
    },
});